import { FormHandler } from '@framework/form/form/FormHandler.tsx';
import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Drawer } from '@framework/ui/components/drawer/Drawer.tsx';
import { Button, type ButtonProps, Collapse, message } from 'antd';
import { BooleanConditionEditorInput } from '../../../../../../inputs/expressions-editor/conditions/BooleanConditionEditorInput.tsx';
import { StaticBooleanConditionSchema } from '../../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema.ts';
import { RichTextAdvancedInput } from '../../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { DrawerEditorButtonRow } from '../../../../../../ui/drawer/DrawerEditorButtonRow.tsx';
import { StyledDrawerCollapse } from '../../../../../../ui/drawer/StyledDrawerCollapse.tsx';
import { type IWidgetOption } from '../../../../Widget.ts';
import { widgetOptionDividerValidator } from './util/widgetOptionValidator.ts';

const { Panel } = Collapse;

export interface IWidgetOptionDividerEditDrawerProps {
  editor: RelationEditor<IWidgetOption>;
  buttonProps?: Omit<ButtonProps, 'onClick'>;
}

export function WidgetOptionDividerEditDrawer(
  props: IWidgetOptionDividerEditDrawerProps,
) {
  const { editor, buttonProps } = props;

  return (
    <>
      <Button
        {...buttonProps}
        onClick={() => {
          editor.handle.open({
            type: 'divider',
            label: [{ type: 'text', text: '' }],
            visible: StaticBooleanConditionSchema.cast({}, { assert: false }),
          });
        }}
      >
        Divisore
      </Button>
      <Drawer
        maskClosable={false}
        title="Configurazione divisore"
        size="large"
        placement="right"
        onClose={editor.handle.cancel}
        open={
          editor.handle.isVisible && editor.handle.current?.type === 'divider'
        }
      >
        <FormHandler
          layout="vertical"
          schema={widgetOptionDividerValidator}
          initialValues={
            editor.handle.current ??
            widgetOptionDividerValidator.cast({}, { assert: false })
          }
          // validate={schemaToValidator(createAccessTokenValidator)}
          onSubmit={async rawValues => {
            try {
              const values =
                await widgetOptionDividerValidator.validate(rawValues);
              const type = editor.handle.apply(values);
              if (type === 'updated') {
                message.success('Divisore modificato');
              } else {
                message.success('Divisore aggiunto');
              }
            } catch (e) {
              // biome-ignore format: <tbd>
              message.error('Si è verificato un errore nella gestione del divisore');
              console.error(e);
            }
          }}
        >
          <FormItem name="label" label="Etichetta">
            <RichTextAdvancedInput
              rows={4}
              name="label"
              menus={MenuPresets.Inline}
            />
          </FormItem>

          {/* TODO Regole di validazione/visibilità */}
          <StyledDrawerCollapse defaultActiveKey={['view']} ghost>
            <Panel header="Regole di Visualizzazione" key="view">
              <FormItem name="visible" label="Visibilità">
                <BooleanConditionEditorInput name="visible" label="Visibile" />
              </FormItem>
            </Panel>
          </StyledDrawerCollapse>

          <DrawerEditorButtonRow editor={editor} />
        </FormHandler>
      </Drawer>
    </>
  );
}
